module.exports = __webpack_public_path__ + "static/media/squareshape.0067967b.jpg";